import { dataroomUrl } from '@dataroom/url';
import dataroomConfig from '@dataroom/config';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import CorrectionButton from '@/creditflowresearch/ui/components/deals/CorrectionModal/CorrectionButton';
import CorrectionModalProvider from '@/creditflowresearch/ui/components/deals/CorrectionModal/CorrectionModalContext';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';
import IconInvestorSet from '@creditflowresearch/uilib/Icon/IconInvestorSet';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Tools/tools.module.scss';

const Tools = ({ row: deal, isExpanded }: { row: IDealCellData, isExpanded: boolean }) => {
  const renderExpandCollapseIcon = () => {
    const Icon = isExpanded ? IconCollapse : IconExpand;
    const tooltip = isExpanded ? 'Collapse' : 'Expand';

    return (
      <Tooltip content={ tooltip }>
        <Icon size={ 12 } data-test="toggleButton" />
      </Tooltip>
    );
  };

  return (
    <div className={ styles.toolsCol }>
      <CorrectionButton
        selectedDeal={ deal }
      />
      <div className={ styles.tool }>
        <div className={ styles.expandCollapseBtn }>
          { renderExpandCollapseIcon() }
        </div>
      </div>
      <div className={ styles.tool }>
        { deal.verified && !deal.investorSetAvailable && (
          <Tooltip content="Transaction Details Verified">
            <IconCheck
              size={ 12 }
              className={ styles.verified }
              data-test="dealRowVerified"
            />
          </Tooltip>
        ) }
        { deal.investorSetAvailable && (
          <div className={ styles.investorSetAvailable }>
            <a
              target="_blank"
              href={ deal.product.abbreviation === AbsProduct.ABBREVIATION
                ? dataroomUrl(dataroomConfig.investorset.code)
                  .getExploreSetsABSUrl()
                : dataroomUrl(dataroomConfig.investorset.code)
                  .getExploreSetsCorporateUrl() }
              data-test="dealRowInvestorSetLink"
              onClick={ (e) => e.stopPropagation() }
            >
              <Tooltip content="Transaction documentation is available on InvestorSet">
                <IconInvestorSet size={ 12 } />
              </Tooltip>
            </a>
          </div>
        ) }
      </div>
    </div>
  );
};

export default (props) => (
  <CorrectionModalProvider>
    <Tools { ...props } />
  </CorrectionModalProvider>
);
